<template>
  <div class="list-page">
    <div v-if="project && project.projectId">
      <div class="layout__content__header list-page__header layout__content__header--white">
        <copy-notification
          :opened="copyConfirmVisible"
          :text="'zkopirovanoDoSchranky'"
          @close="copyConfirmVisible = false"
        />
        <div class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("MQTT_BRANY") }}
          </h1>
        </div>
        <div class="list-page__buttons align-items-center d-flex d-sm-none">
          <button class="btn btn-primary d-flex align-items-center justify-content-center" @click="createNewEndpoint">
            <span class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-nova.svg" />
            </span>
            {{ $t("NEW_MQTT_GATEWAY_BUTTON") }}
          </button>
        </div>

        <div v-if="project" class="d-flex justify-content-between">
          <div class="d-flex list-page__left align-items-center">
            <div
              v-if="project.projectId"
              class="custom-control custom-control--search d-flex align-items-center justify-content-between list-page__search"
            >
              <input
                id="guisearch"
                ref="searchInput"
                v-model="search"
                :placeholder="this.$t('Hledat podle názvu, ID, tagu, …')"
                autofocus
                class="w-100"
                type="text"
                @keyup.enter="searchEndpoints"
              />
              <div v-if="search" class="atom-icon" @click="clearSearch">
                <img alt="" src="@/assets/icons/actions/ico-close.svg" />
              </div>
              <div class="atom-icon" @click="searchEndpoints">
                <img alt="" src="@/assets/icons/actions/ico-search-black.svg" />
              </div>
              <div class="custom-control--search__suggestions">
                <div
                  v-for="(suggestion, index) of suggestionsArray"
                  :key="index"
                  class="custom-control--search__suggestions__item"
                  @click="setSuggestion(suggestion)"
                >
                  <span>{{ suggestion }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="list-page__buttons d-none d-sm-flex align-items-center justify-content-between">
            <button
              v-if="project.projectId"
              class="btn btn-primary d-flex align-items-center justify-content-center"
              @click="createNewEndpoint()"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-nova.svg" />
              </div>
              {{ $t("NEW_MQTT_GATEWAY_BUTTON") }}
            </button>
          </div>
        </div>
      </div>

      <div class="layout__content__header layout__content__header--white pt-0 pb-0">
        <radio-help
          :article-link="'/gate/mqtt'"
          :show="showHelp"
          @changeRadioBtnVisibility="changeRadioBtnVisibility($event)"
          @updateShowRadioHelp="showRadioHelp($event)"
        />
      </div>

      <div v-if="radioSlides.length" class="detail-page__tabs__header d-flex">
        <div class="d-flex align-items-end detail-page__tabs__wrapper mt-5">
          <radio-open-close :radio-slides="radioSlides" :show="showHelp" @updateShowRadioHelp="showRadioHelp($event)" />
        </div>
      </div>
      <div v-if="mqttGatewaysResponse.count > 0" class="layout__content__content pt-4 pt-md-5">
        <div v-if="mqttGatewaysResponse.count > 0" class="position-relative w-100">
          <div id="endpoints" class="table-responsive">
            <table class="table table-main table-hover">
              <thead>
                <tr>
                  <th
                    v-for="(column, index) in columns"
                    :key="index"
                    :class="{ isHidden: !column.visible }"
                    :style="{ 'min-width': column.minWidth }"
                  >
                    <span v-if="column.sortable != true">
                      {{ $t(column.name) }}
                    </span>
                    <span v-else>
                      <div
                        v-if="column.name == 'custDestName'"
                        :class="{ checked: allOnPageSelected() }"
                        class="custom-control custom-control--checkbox"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortBy(column.type)">
                        {{ $t(column.name) }}
                      </div>
                      <div v-if="sort == column.type" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in sortedEndpoints" :key="item_index">
                  <td
                    v-for="(column, column_index) in columns"
                    :key="column_index"
                    :class="{
                      isHidden: !column.visible,
                      disabledEndpoint: !item.custDestEnabled,
                      'position-relative endpointName': column.type == 'custDestName'
                    }"
                    :style="{ width: column.minWidth }"
                  >
                    <span v-if="column.type == 'custDestName'" :class="{ disabledEndpoint: !item.custDestEnabled }">
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.custDestId === item.custDestId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>

                      <router-link
                        :to="{
                          name: 'mqttEndpoint',
                          params: {
                            id: item.custDestId,
                            device: item,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span :style="{ maxWidth: column.minWidth }" style="display: block; word-wrap: break-word">
                          {{ item[column.type] }}
                        </span>
                      </router-link>
                    </span>
                    <span v-else-if="column.type == 'custDestId'">
                      <div v-tooltip :title="item.custDestId">
                        <span class="eui-short">
                          {{ $filters.strLimitEnd(item.custDestId, 6) }}
                        </span>
                      </div>
                    </span>
                    <span v-else-if="column.type == 'protocol'">MQTT</span>
                    <div v-else-if="column.type == 'deviceGroups'">
                      <div
                        v-for="group in item.deviceGroups.slice(0, 1)"
                        :key="group.deviceGroupId + 'g' + item.custDestId"
                        class="d-flex"
                      >
                        <a
                          class="link-gray"
                          @click="
                            $router.push({
                              name: 'group',
                              params: { id: group.deviceGroupId, group: group }
                            })
                          "
                        >
                          <span>
                            {{ $filters.strLimit(group.deviceGroupName, 11) }}
                          </span>
                        </a>
                        <div v-if="item.deviceGroups.length > 1" class="atom-expand" @click="toggleGroup(item)">
                          <span v-if="openedGroups.indexOf(item) > -1">-</span>
                          <span v-else>+</span>
                          {{ item.deviceGroups.length - 1 }}
                        </div>
                      </div>

                      <div v-if="openedGroups.indexOf(item) > -1" class="atom-expand__content d-flex flex-wrap">
                        <div
                          v-for="group in item.deviceGroups.slice(1, item.deviceGroups.length)"
                          :key="group.deviceGroupId + 'g' + item.custDestId"
                          class=""
                        >
                          <a
                            class="link-gray"
                            @click="
                              $router.push({
                                name: 'group',
                                params: {
                                  id: group.deviceGroupId,
                                  group: group
                                }
                              })
                            "
                          >
                            <span>{{ group.deviceGroupName }}</span>
                          </a>
                        </div>
                      </div>

                      <div class="" />
                    </div>
                    <span v-else-if="column.type == 'url'">
                      <div v-tooltip :title="item.custDestParameters.address">
                        {{ $filters.strLimitEnd(item.custDestParameters.address, 36) }}
                      </div>
                      <div
                        v-if="item.custDestParameters.url"
                        class="copy d-flex align-items-center ml-1"
                        @click="copyToClipboard(item.custDestParameters.address)"
                      >
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                    <span v-else>
                      {{ item[column.type] }}
                    </span>
                  </td>
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedEndpoint.custDestId == item.custDestId
                      }"
                      class="kebab"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-first-column">
              <thead>
                <tr>
                  <th>
                    <span v-if="columns[0].sortable != true">
                      {{ $t(columns[0].name) }}
                    </span>
                    <span v-else class="d-flex align-items-center">
                      <div
                        v-if="columns[0].name == 'custDestName'"
                        :class="{
                          checked: allOnPageSelected()
                        }"
                        class="custom-control custom-control--checkbox"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortBy(columns[0].type)">
                        {{ $t(columns[0].name) }}
                      </div>
                      <div v-if="sort == columns[0].type" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in sortedEndpoints" :key="item_index">
                  <td
                    :class="{ disabledEndpoint: !item.custDestEnabled }"
                    :style="{ width: columns[0].minWidth }"
                    class="position-relative endpointName"
                  >
                    <span>
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.custDestId === item.custDestId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>

                      <router-link
                        :to="{
                          name: 'mqttEndpoint',
                          params: {
                            id: item.custDestId,
                            device: item,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span :style="{ maxWidth: columns[0].minWidth }" style="display: block; word-wrap: break-word">
                          {{ item.custDestName }}
                        </span>
                      </router-link>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in sortedEndpoints" :key="item_index">
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedEndpoint.custDestId == item.custDestId
                      }"
                      class="kebab"
                    >
                      <div class="dropdown-actions">
                        <div class="atom-icon d-block mr-0" @click="openKebab(item)">
                          <img src="@/assets/icons/menu/ico-kebab.svg" />
                        </div>
                        <div
                          v-if="openedEndpoint.custDestId == item.custDestId"
                          v-click-outside="closeKebabConf"
                          class="dropdown-actions__wrapper"
                        >
                          <div class="dropdown-actions__inner">
                            <router-link
                              :to="{
                                name: 'mqttEndpoint',
                                params: {
                                  id: item.custDestId,
                                  device: item,
                                  customerId: customerId,
                                  projectId: projectId
                                }
                              }"
                              class="text-decoration-none"
                            >
                              <div class="dropdown-actions__item d-flex align-items-center text-black">
                                <div class="atom-icon">
                                  <img alt="" src="@/assets/icons/actions/icon_preview_border.svg" />
                                </div>
                                <span style="color: #212529">
                                  {{ $t("DETAIL_MQTT_BRANY") }}
                                </span>
                              </div>
                            </router-link>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedEndpoint]
                                  toggleEditEndpointModal('editEndpoint')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
                              </div>
                              {{ $t("upravitEndpoint") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              cols="6"
                              @click="
                                () => {
                                  actionItems = [openedEndpoint]
                                  toggleDeleteModal()
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                              </div>
                              {{ $t("odstranitEndpoint") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          v-if="mqttGatewaysResponse.count > 0"
          class="custom-table__footer d-flex align-items-center justify-content-between"
        >
          <div class="w-50" />
          <paging
            :page="{
              currentPage: page,
              rowsPerPage: rowsPerPage,
              itemsTotalCount: mqttGatewaysResponse.count,
              itemsCount: mqttGatewaysResponse.data.length
            }"
            @nextPage="page++"
            @page="page = $event"
            @prevPage="page--"
            @reloadItems="reloadEndpoints()"
            @rowsPerPage="rowsPerPage = $event"
          />
        </div>
      </div>
      <div v-else-if="!loadingData" class="layout__content__content pt-4 pt-md-5">{{ $t("nicKZobrazeni") }}.</div>
      <div v-else class="layout__content__content pt-4 pt-md-5">
        <app-loader />
      </div>
    </div>
    <div v-else>
      <div class="layout__content__header list-page__header">
        <div class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("endpointy") }}
          </h1>
        </div>
      </div>
    </div>
    <new-endpoint-modal
      :opened="openedNewEndpoint"
      :tags="tags"
      protocol="MQTT"
      @closeBox="closeNewEndpointModal"
      @openBox="openNextNewEndpointModal"
      @reloadItems="reloadEndpoints"
    />
    <add-to-groups-modal
      :endpoints="actionItems"
      :opened="openedAddToGroups"
      :tags="tags"
      @closeBox="toggleAddToGroupsModal"
      @openBox="toggleAddToGroupsModal"
      @reloadItems="reloadEndpoints"
    />
    <remove-from-groups-modal
      :endpoints="actionItems"
      :opened="openedRemoveFromGroups"
      :tags="tags"
      @closeBox="toggleRemoveFromGroupsModal"
      @openBox="toggleRemoveFromGroupsModal"
      @reloadItems="reloadEndpoints"
    />
    <delete-endpoint-modal
      :centered="true"
      :items="actionItems"
      :opened="isDeleteModalOpen"
      :text="deleteText"
      @close="toggleDeleteModal()"
      @yes="
        () => {
          handleDeleteGateway()
          toggleDeleteModal()
        }
      "
    />
    <edit-endpoint-modal
      v-if="openedEditEndpoint.length > 0"
      :opened="openedEditEndpoint"
      :original-endpoint="actionItems[0]"
      protocol="MQTT"
      @closeBox="toggleEditEndpointModal"
      @openBox="toggleEditEndpointModal"
      @reloadItems="reloadEndpoints"
    />
    <table-column-order
      v-if="showSidebarTableColumnOrder"
      :columns="tableColumns"
      :columns-type="columnsTypeName"
      :opened="showSidebarTableColumnOrder"
      @closeBox="closeSidebarTableColumnOrder()"
    />
    <error-modal
      v-if="errorsToTranslate.length"
      :centered="true"
      :errors="errorsToTranslate"
      :opened="openedError"
      @close="openedError = false"
    />
  </div>
</template>
<script>
import axios from "axios"
import _ from "lodash"
import Paging from "@/components/paging/paging.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import NewEndpointModal from "@/components/modals/endpoints/new.vue"
import DeleteEndpointModal from "@/components/confirmations/delete.vue"
import EditEndpointModal from "@/components/modals/endpoints/edit.vue"
import AddToGroupsModal from "@/components/modals/endpoints/addToGroups.vue"
import RemoveFromGroupsModal from "@/components/modals/endpoints/removeFromGroups.vue"
import TableColumnOrder from "@/components/modals/global/tableColumnOrder.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import Notify from "@/components/notify/notify.vue"
import Loader from "@/components/loader.vue"
import { mapMutations } from "vuex"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"
import { useEndpointsStore } from "@/store/modules/endpoints"
import { useGatewaysStore } from "@/store/modules/gateways"

export default {
  components: {
    Paging,
    NewEndpointModal,
    DeleteEndpointModal,
    RadioHelp,
    RadioOpenClose,
    EditEndpointModal,
    AddToGroupsModal,
    RemoveFromGroupsModal,
    ErrorModal,
    CopyNotification: Notify,
    TableColumnOrder,
    AppLoader: Loader
  },
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const endpointsStore = useEndpointsStore()
    const gatewaysStore = useGatewaysStore()

    return { projectStore, configStore, endpointsStore, gatewaysStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      tableWidth: 0,
      columns: [
        {
          type: "custDestName",
          name: "custDestName",
          sortable: true,
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "custDestId",
          name: "custDestId",
          sortable: true,
          visible: true,
          minWidth: "120px",
          order: 2
        },
        {
          type: "protocol",
          name: "protocol",
          sortable: false,
          visible: true,
          minWidth: "100px",
          order: 3
        },
        {
          type: "deviceGroups",
          name: "deviceGroups",
          sortable: false,
          visible: true,
          minWidth: "200px",
          order: 4
        },
        {
          type: "url",
          name: "rootTopic",
          sortable: false,
          visible: true,
          minWidth: "500px",
          order: 5
        }
      ],
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      columnsTypeName: "columnsEndpoints",
      search: "",
      suggested: "",
      suggestionsArray: [],
      isActionsDropdownVisible: false,
      sort: "custDestName",
      sortType: "asc",
      rowsPerPage: 20,
      page: 0,
      openedRowsSelect: false,
      selectedRows: [],
      selectedAll: false,
      isSelectedAllOnPage: false,
      openedSideBox: false,
      openedEndpoint: {},
      openedGroups: [],
      openedTags: [],
      toggledAllRows: false,
      openedNewEndpoint: [],
      tags: [],
      toDelete: [],
      isDeleteModalOpen: false,
      pingResponses: [],
      openedPingEndpoint: false,
      openedEditEndpoint: [],
      openedAddToGroups: [],
      openedRemoveFromGroups: [],
      copyConfirmVisible: false,
      actionItems: [],
      errorsToTranslate: [],
      openedError: false,
      sortedEndpoints: [],
      loaded: true,
      loadingData: true,
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      tableColumnsDefault: {
        custDestId: {
          show: true,
          order: 2,
          title: "custDestId"
        },
        protocol: {
          show: true,
          order: 3,
          title: "protocol"
        },
        deviceGroups: {
          show: true,
          order: 4,
          title: "deviceGroups"
        },
        url: {
          show: true,
          order: 5,
          title: "rootTopic"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false
    }
  },
  computed: {
    mqttGatewaysResponse() {
      return this.endpointsStore.mqttGatewaysResponse
    },
    openNewEndpointModalOnLoad() {
      return this.$store.getters["modals/ifNewEndpointVisible"]
    },
    project() {
      return this.projectStore.selectedProject
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    },
    deleteText() {
      let result = ""
      if (this.actionItems.length > 1) {
        result = "endpointy"
      } else if (this.actionItems.length === 1) {
        result = this.actionItems[0].custDestName
      }
      return result
    }
  },
  watch: {
    search() {
      if (this.suggested == "") {
        if (this.search.length > 1) {
          this.suggestions()
        }
      } else {
        this.suggested = ""
      }
    },
    project() {
      this.loadEndpoints()
      this.selectedRows = []
    },
    sort() {},
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      this.isSelectedAllOnPage = false
      var selectedDevices = this.mqttGatewaysResponse.data
      let selectedDevicesId = selectedDevices.map((d) => d.custDestId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allEndpointsId = selectedAllRowsArray.map((d) => d.custDestId)
      this.isSelectedAllOnPage = selectedDevicesId.every((ai) => allEndpointsId.includes(ai)) ? true : false
    },
    mqttGatewaysResponse() {
      this.getAllTags()
    },
    isActionsDropdownVisible() {
      if (this.isActionsDropdownVisible == true) {
        this.openedEndpoint = {}
      }
    },
    openNewEndpointModalOnLoad() {
      if (this.openNewEndpointModalOnLoad) {
        this.createNewEndpoint()
        this.$store.commit("modals/setNewEndpointVisible", {
          showNewEndpoint: false
        })
      }
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.showHelp = !this.radioDisabled
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })

    this.tableColumns = this.getTableColumns()

    if (localStorage.rowsPerPage) {
      var rows1 = localStorage.rowsPerPage
      this.rowsPerPage = rows1
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    if (this.project) {
      this.loadEndpoints()
    }
    if (this.openNewEndpointModalOnLoad) {
      this.createNewEndpoint()
      this.$store.commit("modals/setNewEndpointVisible", {
        showNewEndpoint: false
      })
    }
  },
  methods: {
    ...mapMutations({
      setNotifications: "modals/setGlobalNotification"
    }),
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "endpoints")
    },
    async loadEndpoints() {
      if (
        this.$route.params.notifications &&
        this.$route.params.notifications[0] &&
        this.$route.params.notifications[0].text
      ) {
        this.$store.commit("modals/setGlobalNotification", this.$route.params.notifications)
      }

      let endpoints = await this.endpointsStore.getMqttGateways({
        sort: this.sort,
        rowsPerPage: this.rowsPerPage,
        currentPage: this.page
      })
      if (endpoints) {
        this.loaded = true
        this.loadingData = false
        this.sortedEndpoints = [].concat(this.mqttGatewaysResponse.data)
        this.$nextTick(() => {
          this.updateResponsiveTable()
        })
      }
    },
    searchEndpoints() {
      this.suggestionsArray = []
      this.sortedEndpoints = this.mqttGatewaysResponse.data.filter(
        (endpoint) => endpoint.custDestName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      )
    },
    reloadEndpoints() {
      this.openedNewEndpoint = []
      this.openedAddToGroups = []
      this.openedRemoveFromGroups = []
      this.loadEndpoints()
    },
    suggestions() {
      axios
        .get(
          process.env.VUE_APP_API +
            "/http/endpoints/suggestions?projectId[eq]=" +
            this.project.projectId +
            "&search=" +
            this.search +
            "*"
        )
        .then((response) => {
          this.suggestionsArray = response.data.data
        })
        .catch(() => {})
    },
    setSuggestion(suggestion) {
      this.suggested = suggestion
      this.search = suggestion
      this.searchEndpoints()
      this.suggestionsArray = []
    },
    clearSearch() {
      this.search = ""
      this.suggested = ""
      this.searchEndpoints()
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = this.isActionsDropdownVisible ? false : true
    },
    sortBy(sortBy) {
      let sorted
      this.isSelectedAllOnPage = false
      this.sort = sortBy
      if (this.sortType == "asc") {
        sorted = _.orderBy(this.sortedEndpoints, `${sortBy}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.sortedEndpoints, `${sortBy}`, "asc")
        this.sortType = "asc"
      }
      this.dateChanged = false
      this.sortedEndpoints = sorted
    },
    toggleOpenedRowSelect() {
      this.openedRowsSelect = this.openedRowsSelect ? false : true
    },
    addToSelected(device) {
      if (this.selectedRows.filter((e) => e.custDestId === device.custDestId).length > 0) {
        const index = this.selectedRows.map((e) => e.custDestId).indexOf(device.custDestId)
        this.selectedRows.splice(index, 1)
      } else {
        this.selectedRows.push(device)
      }
    },
    toggleGroup(device) {
      var index = this.openedGroups.indexOf(device)
      if (this.openedGroups.indexOf(device) > -1) {
        this.openedGroups.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedGroups.push(device)
      }
    },
    toggleTag(device) {
      var index = this.openedTags.indexOf(device)
      if (this.openedTags.indexOf(device) > -1) {
        this.openedTags.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedTags.push(device)
      }
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedTags = []
        this.openedGroups = []
        this.toggledAllRows = false
      } else {
        this.openedTags = [].concat.apply([], this.mqttGatewaysResponse.data)
        this.openedGroups = [].concat.apply([], this.mqttGatewaysResponse.data)
        this.toggledAllRows = true
      }
    },
    selectAll(type) {
      this.isSelectedAllOnPage = true
      var selectedDevices = this.sortedEndpoints
      let selectedDevicesId = selectedDevices.map((d) => d.custDestId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allEndpointsId = selectedAllRowsArray.map((d) => d.custDestId)
      if (type === "deselect") {
        this.selectedRows = []
        this.isSelectedAllOnPage = false
      } else if (type === "selectAll") {
        this.selectedRows = [].concat.apply([], this.sortedEndpoints)
        this.isSelectedAllOnPage = true
      } else {
        if (selectedDevicesId.every((ai) => allEndpointsId.includes(ai))) {
          let indexes = []
          selectedDevices.forEach((element) => {
            indexes.push(selectedAllRowsArray.indexOf(element))
          })
          this.selectedRows.splice(indexes[0], indexes.length)
        } else {
          let indexes = []
          let same = []
          this.selectedRows.forEach((selected) => {
            let filteredArray = selectedDevices.filter((e) => e.custDestId === selected.custDestId)
            same.push(filteredArray[0])
          })
          same.forEach((element) => {
            if (element != undefined) {
              indexes.push(this.selectedRows.findIndex((obj) => obj.custDestId == element.custDestId))
            }
          })
          for (var i = indexes.length - 1; i >= 0; i--) {
            this.selectedRows.splice(indexes[i], 1)
          }
          this.selectedRows =
            this.selectedRows.length > 0
              ? this.selectedRows.concat.apply(this.selectedRows, selectedDevices)
              : [].concat.apply([], selectedDevices)
        }
      }
    },
    allOnPageSelected() {
      let itemsOnPage = this.sortedEndpoints
      let itemsOnPageId = itemsOnPage.map((d) => d.custDestId)
      let allItemsId = Array.from(this.selectedRows).map((d) => d.custDestId)
      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        return true
      } else {
        return false
      }
    },
    openKebab(device) {
      this.openedEndpoint = this.openedEndpoint == device ? {} : device
    },
    closeKebab() {
      this.openedEndpoint = {}
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    toggleSideBox(box) {
      this.openedSideBox = box == false ? false : box
    },
    toggleNewEndpoint() {
      this.openedNewEndpoint = this.openedNewEndpoint ? false : true
    },
    createNewEndpoint() {
      this.openedNewEndpoint = this.openedNewEndpoint.concat(["newEndpoint"])
    },
    closeNewEndpointModal(box) {
      box == undefined
        ? (this.openedNewEndpoint = [])
        : (this.openedNewEndpoint = this.openedNewEndpoint.filter((item) => item !== box))
    },
    openNextNewEndpointModal(box) {
      this.openedNewEndpoint = this.openedNewEndpoint.concat([box])
    },
    getAllTags() {
      this.tags = _(this.mqttGatewaysResponse.data)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
    },
    toggleDeleteModal() {
      this.isDeleteModalOpen = !this.isDeleteModalOpen
    },
    async handleDeleteGateway() {
      this.errorsToTranslate = []
      let notifications = []
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
      for (const item of this.actionItems) {
        try {
          await this.gatewaysStore.deleteGateway(item.custDestId)
          this.selectedRows = this.selectedRows.filter(function (obj) {
            return obj.custDestId !== item.custDestId
          })
          notifications.push({
            text: "notificationEndpointDelete",
            error: false,
            params: {
              custDestId: item.custDestId,
              custDestName: item.custDestName
            }
          })
        } catch (error) {
          let message = error.data.errors[0]
          this.errorsToTranslate.push({
            errors: [
              {
                message: message,
                attribute: {
                  custDestId: item.custDestId,
                  custDestName: item.custDestName
                }
              }
            ]
          })
        }
      }
      if (this.errorsToTranslate.length > 0) {
        this.$store.commit("modals/setWaitingLoader", "")
        this.openedError = true
        return
      }
      this.reloadEndpoints()
      this.$store.commit("modals/setWaitingLoader", "")
      this.setNotifications(notifications)
    },
    pingRepeat(item) {
      this.pingResponses.splice(this.pingResponses.indexOf(item), 1)
      this.ping([item])
    },
    closePingModal(item) {
      this.pingResponses.splice(this.pingResponses.indexOf(item), 1)
      if (this.pingResponses.length < 1) {
        this.openedPingEndpoint = false
      }
    },
    ping(endpoint) {
      if (this.isActionsDropdownVisible) {
        this.showDropdownActions()
      }
      let array = endpoint == undefined ? this.actionItems : endpoint
      array.forEach((item) => {
        let id = item.custDestId
        axios
          .get(process.env.VUE_APP_API + "/http/endpoints/" + id + "/ping", {})
          .then((response) => {
            let obj = { endpoint: item, response: response.data.status }
            this.pingResponses.push(obj)
            this.openedPingEndpoint = true
            this.closeKebab()
          })
          .catch((response) => {
            let obj = {
              endpoint: item,
              response: "error",
              message: response.data.errors.join(",")
            }
            this.openedPingEndpoint = true
            this.pingResponses.push(obj)
            this.closeKebab()
          })
      })
    },
    toggleEditEndpointModal(box) {
      if (this.openedEditEndpoint.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditEndpoint = [])
          : this.openedEditEndpoint.splice(this.openedEditEndpoint.indexOf(box), 1)
        //this.selectedRows = [];
        this.selectedAll = false
      } else {
        this.openedEditEndpoint.push(box)
      }
    },
    toggleAddToGroupsModal(box) {
      if (this.openedAddToGroups.indexOf(box) > -1) {
        box == undefined
          ? (this.openedAddToGroups = [])
          : this.openedAddToGroups.splice(this.openedAddToGroups.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedAddToGroups.push(box)
      }
    },
    toggleRemoveFromGroupsModal(box) {
      if (this.openedRemoveFromGroups.indexOf(box) > -1) {
        box == undefined
          ? (this.openedRemoveFromGroups = [])
          : this.openedRemoveFromGroups.splice(this.openedRemoveFromGroups.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedRemoveFromGroups.push(box)
      }
    },
    switchEndpoints(value) {
      let array = this.actionItems
      this.errorsToTranslate = []
      let promises = []
      array.forEach((item) => {
        let id = item.custDestId
        item.custDestDescription = ""
        if (value == undefined) {
          item.custDestEnabled = item.custDestEnabled ? false : true
        } else {
          item.custDestEnabled = value
        }
        promises.push(
          axios
            .put(process.env.VUE_APP_API + "/http/endpoints/" + id, item, {})
            .then(() => {})
            .catch(() => {})
        )
      })
      Promise.all(promises).then(() => {
        this.openedError = true
      })
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    middlewareKebab(event) {
      return event.target.className !== "custom-control-label"
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      this.showSidebarTableColumnOrder = false
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>
<style lang="scss" scoped></style>
